export default __webpack_public_path__ + "static/media/lmpm.2784c487.png";